import { ApolloLink, Observable, Operation } from "@apollo/client";
import { reportServerVersion } from "./versionSignal";

export const versionHeader = "X-Wolfkrow-Version";

// Best-effort: listeners run synchronously in here, and a throw must never stop
// the result or error from being forwarded.
const reportVersionFrom = (operation: Operation) => {
  try {
    const response: Response | undefined = operation.getContext().response;
    const version = response?.headers?.get(versionHeader);
    if (version) {
      reportServerVersion(version);
    }
    // eslint-disable-next-line no-empty
  } catch {}
};

/**
 * Reports the backend version from every GraphQL response, so a tab loaded
 * before a deploy learns it is stale on its next request.
 *
 * HttpLink puts the fetch Response on the operation context before checking
 * its status, so it is there on the error path too: a non-2xx response arrives
 * here as an error, which is why this subscribes rather than using `.map`. A
 * network failure has no response and reports nothing.
 */
export const versionLink = new ApolloLink(
  (operation, forward) =>
    new Observable((observer) => {
      const subscription = forward(operation).subscribe({
        next: (result) => {
          reportVersionFrom(operation);
          observer.next(result);
        },
        error: (error) => {
          reportVersionFrom(operation);
          observer.error(error);
        },
        complete: () => observer.complete(),
      });

      return () => subscription.unsubscribe();
    })
);
